import { render, staticRenderFns } from "./sitemap.vue?vue&type=template&id=f7d677a2"
import script from "./sitemap.vue?vue&type=script&lang=js"
export * from "./sitemap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports